import './ChapterItem.less';
import React, {useState} from 'react';
import Icon from "../../../../../bootstrap/components/icon/Icon";
import LessonList from "../lesson-list/LessonList";
import __ from '../../../../i18n';


export default function ChapterItem({chapter, lessons}) {

    const [expanded, setExpanded] = useState(false);

    return <li className="chapter-item">
        <div className="inline" onClick={() => setExpanded(!expanded)}>
            {
                expanded
                ? <Icon name="angle-up"/>
                : <Icon name="angle-down"/>
            }
            <div className="chapter-name">{chapter.name}</div>
            <div className="lesson-count">{__('::count(PLURAL, 1 1 item, ! :@ items)', {count: lessons.length})}</div>
        </div>
        {
            expanded &&
            <LessonList lessons={lessons}/>
        }
    </li>;
}
